//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Lane",
  props: {
    label: String,
    aiModels: Array,
    hideMenu: {
      type: Boolean,
      value: false,
    }
  },
  data: () => ({
    showMore: true
  }),
}
